import { License } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import useWizardContext from '@swf/core/hooks/useWizardContext';
import { select } from '@swf/core/store';

import Fill from '../../../../assets/icons/fill.svg';
import { CashierFlowType, type HelpSection } from '../../../../types/Cashier';
import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';
import PaymentMethodDetailsSummary from '../../../Deposit/components/PaymentMethodDetailsSummary/PaymentMethodDetailsSummary';
import TransactionsPanel from '../../../TransactionsPanel/TransactionsPanel';

import HelpSectionContent from './HelpSectionContent/HelpSectionContent';
import {
  TXTWCL_Back_to_Cashier,
  TXTWCL_Review_may_take_up_to_48_hours,
  TXTWCL_WeXre_reviewing_your_payment_m_ELL,
  TXTWCL_You_can_still_use_it_to_make_d_ELL,
  TXTWCL_You_cannot_withdraw_any_money__ELL,
  TXTWCL_You_cannot_withdraw_any_money__ELL_1,
  TXTWCL_You_will_get_an_email_when_you_ELL,
  TXTWCL_You_will_get_an_email_when_you_ELL_1,
  TXTWCL_Your_payment_information_has_b_ELL,
  TXTWCL_Your_payment_information_is_be_ELL
} from './PaymentVerificationSummary.messages.json';
import { container, content, contentMessage, info } from './PaymentVerificationSummary.scss';

const helpSection: HelpSection = {
  title: TXTWCL_WeXre_reviewing_your_payment_m_ELL,
  body: <HelpSectionContent />
};

const PaymentVerificationSummary: React.FC = () => {
  const {
    data: { cashierFlow, unverifiedOptions = [] },
    values: { deposit, withdraw }
  } = useWizardContext();
  const license = useSelector(select.account.getLicense);

  const titleMessage =
    cashierFlow === CashierFlowType.FirstWithdraw ? (
      <Translation {...TXTWCL_Your_payment_information_is_be_ELL} />
    ) : (
      <Translation {...TXTWCL_Your_payment_information_has_b_ELL} />
    );

  const contentTranslation =
    unverifiedOptions.length > 1 ? (
      <Translation {...TXTWCL_You_cannot_withdraw_any_money__ELL_1} />
    ) : (
      <Translation {...TXTWCL_You_cannot_withdraw_any_money__ELL} />
    );

  const emailTranslation =
    cashierFlow === CashierFlowType.FirstWithdraw ? (
      unverifiedOptions.length > 1 ? (
        <Translation {...TXTWCL_You_will_get_an_email_when_you_ELL_1} />
      ) : (
        <Translation {...TXTWCL_You_will_get_an_email_when_you_ELL} />
      )
    ) : (
      <Translation {...TXTWCL_You_will_get_an_email_when_you_ELL} />
    );

  const showBackButton =
    (cashierFlow === CashierFlowType.FirstDeposit && license === License.ES) ||
    cashierFlow === CashierFlowType.FirstWithdraw
      ? false
      : true;

  return (
    <Container
      headerProps={{
        title: titleMessage,
        buttons: {
          back: showBackButton
        }
      }}
      page={PaymentVerificationSummary}
      pageTopTitle={titleMessage}
      helpSection={helpSection}
      helpSupportResolver
      showFooter
    >
      {cashierFlow === CashierFlowType.FirstWithdraw ? (
        <TransactionsPanel
          balanceCurrency={withdraw.balanceCurrency}
          rollbackOverCreditOptions={unverifiedOptions}
          isVerification
        />
      ) : (
        <PaymentMethodDetailsSummary type={deposit.type} variant="verification" />
      )}

      <div className={info}>{emailTranslation}</div>
      {cashierFlow === CashierFlowType.FirstWithdraw && (
        <div className={contentMessage}>
          {contentTranslation} <Translation {...TXTWCL_You_can_still_use_it_to_make_d_ELL} />
        </div>
      )}
      <div className={container}>
        <p className={content}>
          <Fill />
          <Translation {...TXTWCL_Review_may_take_up_to_48_hours} />
        </p>
      </div>
      <CTAButton translation={TXTWCL_Back_to_Cashier} alias="firstWalletHome" />
    </Container>
  );
};

PaymentVerificationSummary.displayName = 'PaymentVerificationSummary';

export default PaymentVerificationSummary;
